export default (text: string, substring?: string): boolean => {
  if (substring !== undefined && substring.length > 0) {
    return text.toLowerCase().includes(substring.toLowerCase());
  }
  return true;
};
